"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteOrgMemberRequestStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
exports.InviteOrgMemberRequestStruct = (0, superstruct_1.type)({
    organisationId: (0, superstruct_1.string)(),
    email: (0, superstruct_1.string)(),
    role: types_1.OrgMemberStruct.schema['role'],
});
//# sourceMappingURL=InviteOrgMemberRequest.js.map